import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

import App from './App.vue';
import router from './router';

const app = createApp(App);

// 注册 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(createPinia());
app.use(router);
app.use(ElementPlus, { locale: zhCn });

// 全局错误处理器 —— 防止白屏
app.config.errorHandler = (err, instance, info) => {
  console.error('[Vue Error]', err, info);
  // 开发模式下在页面显示错误信息
  const el = document.getElementById('app');
  if (el && import.meta.env.DEV) {
    const existing = el.querySelector('.error-boundary');
    if (existing) existing.remove();
    const div = document.createElement('div');
    div.className = 'error-boundary';
    div.style.cssText = 'padding:40px;text-align:center;color:#e53935;font-family:monospace;background:#fff;z-index:99999;position:relative;';
    div.innerHTML = `
      <h3 style="margin-bottom:12px;">⚠️ 组件渲染错误</h3>
      <pre style="text-align:left;background:#f5f5f5;padding:16px;border-radius:8px;overflow:auto;font-size:12px;max-width:600px;margin:0 auto;">${String(err.stack || err.message || err)}</pre>
      <p style="margin-top:12px;color:#666;">${info}</p>
      <button onclick="localStorage.removeItem(\'access_token\');location.reload()" style="margin-top:16px;padding:8px24px;background:#409eff;color:#fff;border:none;border-radius:4px;cursor:pointer;">🔄 重置并刷新</button>
    `;
    el.prepend(div);
  }
};

app.mount('#app');
